// submitOnChange
$(document).on(
  'change',
  'form input.submitOnChange, form select.submitOnChange',
  function () {
    $(this).parents('form').submit();
  }
);
